import * as React from 'react';
import {
  TextField,
  IconButton,
  InputLabel,
  FormHelperText,
  InputAdornment
} from '@mui/material';
import { FileUploadOutlined } from "@mui/icons-material";
import { TypingValidateEmail } from '../../../util/General';
import { NumericFormat } from 'react-number-format';

const NumericFormatCustom = React.forwardRef(
  function NumericFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
        prefix="$"
      />
    );
  },
);

export const MoneyOnly = ({ id, value, updateValue, path, description, errors, visible, label }) => {
  // console.log('value', value)
  const [validationError, setValidationError] = React.useState('')
  const [touched, setTouched] = React.useState(false)

  const handleChange = (event) => {
    let initialValue = +event.target.value;
    const data = {
      value: isNaN(initialValue) ? 0 : initialValue,
      is_valid: !isNaN(initialValue),
    };
    updateValue(data.value);
    if (!data.is_valid) {
      setValidationError('Not a valid currency')
    } else {
      setValidationError('')
    }
  };

  const handleTouch = () => {
    setTouched(true);
  };

  const handleTouchOut = () => {
    setTouched(false);
  };

  return (
    <div id={`#/properties/${path}`} className={path} style={{ display: visible ? 'block' : 'none' }}>
      <TextField
        variant="standard"
        value={value ?? ''}
        fullWidth={true}
        style={{ marginBottom: errors ? '0px' : undefined }}
        error={errors || validationError ? true : false}
        label={label}
        helperText={validationError ? validationError : touched && description}
        onChange={handleChange}
        onFocus={handleTouch}
        onBlur={handleTouchOut}
        InputProps={{
          inputComponent: NumericFormatCustom,
        }}
      />
      { errors &&
        <FormHelperText error={true} filled={true}>{errors}</FormHelperText>
      }
    </div>
  );
};
